import { useCallback, useContext, useMemo } from 'react';
import { FormikHelpers } from 'formik';
import { message } from 'antd';

import { IBranchPartnerFormValues } from '../../interfaces';
import { CreateBranchPartnerContext } from '../../context';
import { CreateBranchPartnerMapper } from '../../mappers';
import { BranchPartnersService } from '../../services';
import { useBranchPartnerById } from './use-branch-partner-by-id';

export const useBranchPartnerForm = () => {
  const { id, onSucceed } = useContext(CreateBranchPartnerContext);

  const branchPartner = useBranchPartnerById(id, { enabled: !!id });

  const initialValues = useMemo<IBranchPartnerFormValues | undefined>(() => {
    if (id) {
      return branchPartner.data ? CreateBranchPartnerMapper.toDomain(branchPartner.data) : undefined;
    }
    return { id: '', name: '', isOwner: false, description: '', contact: '', stateId: '' };
  }, [branchPartner.data, id]);

  const onSubmit = useCallback(
    async (values: IBranchPartnerFormValues, helpers: FormikHelpers<IBranchPartnerFormValues>) => {
      helpers.setStatus(null);
      const result = await BranchPartnersService.save({ ...values, id: id || '' });

      if (result.status === 200) {
        onSucceed?.();
      } else if (result.status === 422) {
        helpers.setErrors(result.data);
      } else {
        message.error(result.data as string);
      }

      helpers.setSubmitting(false);
    },
    [id, onSucceed],
  );

  return { onSubmit, initialValues };
};
